// Форматы и цвета вкладки «ABC-анализ»
import React from 'react';
import { Box } from '@mui/material';
import { MUTED_TEXT_COLOR } from '../../../../styles/tokens';
import { ABC_LETTER_COLORS } from '../../utils/abcCalculations';

// Деньги — как на «Себестоимости»: целые рубли
export const money = (value) => `${Math.round(Number(value) || 0).toLocaleString('ru-RU')} ₽`;
// Порции: весовые блюда — до трёх знаков, без хвостовых нулей (2,5 — не 2,500)
export const quantity = (value) => (Number(value) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 3 });
export function plural(n, [one, few, many]) {
  const mod10 = Math.abs(n) % 10;
  const mod100 = Math.abs(n) % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

// Доли — всегда один знак после запятой: «5,0 %»
export const percent = (value) =>
  `${(Number(value) || 0).toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;

export const TAG_COLORS = {
  core: '#66bb6a',
  promote: '#42a5f5',
  remove: '#ef6b6b',
  check: '#f0a43a',
  keep: MUTED_TEXT_COLOR,
};

// Плашка буквы: тёмная буква на цвете группы
export function AbcLetter({ letter, title }) {
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 800,
        color: '#141416',
        backgroundColor: ABC_LETTER_COLORS[letter],
        flexShrink: 0,
      }}
    >
      {letter}
    </Box>
  );
}

// Три плашки блюда: продажи в штуках, выручка, прибыль. Каждая — в своём слоте LETTER_SLOT, чтобы подписи
// заголовка таблицы (AbcLettersHeader) стояли ровно над ними
export const LETTER_SLOT = 30;
const slotSx = { width: LETTER_SLOT, display: 'inline-flex', justifyContent: 'center', flexShrink: 0 };

export function AbcLetters({ abc }) {
  return (
    <Box component="span" sx={{ display: 'inline-flex' }}>
      <Box component="span" sx={slotSx}><AbcLetter letter={abc.qty} title={`Продажи в штуках: ${abc.qty}`} /></Box>
      <Box component="span" sx={slotSx}><AbcLetter letter={abc.revenue} title={`Выручка: ${abc.revenue}`} /></Box>
      <Box component="span" sx={slotSx}><AbcLetter letter={abc.profit} title={`Прибыль: ${abc.profit}`} /></Box>
    </Box>
  );
}

export function AbcLettersHeader() {
  return (
    <Box component="span" sx={{ display: 'inline-flex', whiteSpace: 'nowrap' }} title="Продажи в штуках, выручка, прибыль">
      {['шт', '₽', 'приб.'].map((label) => (
        <Box component="span" key={label} sx={slotSx}>{label}</Box>
      ))}
    </Box>
  );
}
